/**
 * Decodes the payload of a JWT without verifying the signature.
 * Returns null if the token is missing or malformed.
 */
const parseJwt = <T = Record<string, unknown>>(token: string): T | null => {
    try {
        const base64Url = token.split(".")[1];
        if (!base64Url) return null;
        const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
        return JSON.parse(atob(base64)) as T;
    } catch {
        return null;
    }
};

export default parseJwt;
